module.exports = __webpack_public_path__ + "static/img/bbc-right.09a389d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/bbc-right.png
// module id = 330
// module chunks = 1